import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

export const TagTypes = [
  'success',
  'successSecondary',
  'error',
  'errorSecondary',
  'alertSecondary',
  'default',
] as const;

const modifiers = {
  success: () => css`
    background-color: ${theme.colors.supportSuccess};
    color: ${theme.colors.white};

    &::before {
      background-color: ${theme.colors.white};
    }
  `,
  successSecondary: () => css`
    background-color: ${theme.colors.secondaryAlpha20};
    color: ${theme.colors.supportSuccessDark};

    &::before {
      background-color: ${theme.colors.supportSuccessDark};
    }
  `,
  error: () => css`
    background-color: ${theme.colors.supportErrorDark};
    color: ${theme.colors.white};

    &::before {
      background-color: ${theme.colors.white};
    }
  `,
  errorSecondary: () => css`
    background-color: ${theme.colors.supportErrorAlpha20};
    color: ${theme.colors.supportErrorDark};

    &::before {
      background-color: ${theme.colors.supportErrorDark};
    }
  `,
  alertSecondary: () => css`
    background-color: ${theme.colors.supportAlertAlpha20};
    color: ${theme.colors.supportAlertDark};

    &::before {
      background-color: ${theme.colors.supportAlertDark};
    }
  `,
  default: () => css`
    background-color: ${theme.colors.gray2};
    color: ${theme.colors.gray6};

    &::before {
      background-color: ${theme.colors.gray6};
    }
  `,
};

const tagProps = {
  type: String,
  dot: Boolean,
};

export type TagProps = {
  type: typeof TagTypes[number];
  dot: boolean;
};

export const Wrapper = styled('span', tagProps)`
  ${({ type, dot }: TagProps) => css`
    align-items: center;
    border-radius: 0.25em;
    display: inline-flex;
    font-size: inherit;
    line-height: 1.5em;
    padding: 0 .3em;

    ${modifiers[type]}

    &::before {
      border-radius: ${theme.border.radius.circle};
      height: 0.313em;
      margin-right: ${theme.spacings.xxsmall};
      width: 0.313em;

      ${dot && "content: ''"};
    }
  `}
`;
